import moment from 'moment'
import series from '@/application/lib/series'
import calculation from '@/application/lib/calculations'

export default {
    data() {
        return {
            converting: false,
            combineForm: {
                visible: false,
                loading: false,
                items: [],
                date: moment(),
            },
        }
    },
    methods: {
        // Check if is a valid invoice combination
        isEligibleForCombine(invoices) {
            if (!invoices.length || invoices.length === 1) return false

            let eligible = true
            let client = null
            let message = ''

            invoices.forEach((invoice) => {
                if (!client) client = invoice.client._EntityId

                if (client !== invoice.client._EntityId) {
                    eligible = false
                    message = 'No se pueden combinar albaranes de distintos clientes'
                } else if (invoice.invoice) {
                    eligible = false
                    message = 'Algún albaran seleccionado ya ha sido transformado a factura'
                }
            })

            return {
                ok: eligible,
                message: message,
            }
        },
        // Combine multiple invoices into a single bill
        async combineInvoices() {
            const invoices = this.combineForm.items
            const date = this.combineForm.date

            if (!this.isEligibleForCombine(invoices)) return
            if (!invoices.length) return
            this.converting = true

            const bill = {
                // Client
                client: null,
                client_address: null,
                client_cif: null,
                client_country: null,
                client_location: null,
                client_name: null,
                client_legal_name: null,
                client_cp: null,
                client_state: null,

                // General
                _EntityId: null,
                date: date,
                status: 0, // Default State
                observations: '', // Empty
                concepts: [],

                // Serie
                serie: null,
                serie_r: null,

                // Calculations
                total: 0,
                subtotal: 0,
                surcharge: 0,
                surcharge_percent: 0,
                iva: 0,
                iva_percent: 0,
                discount: 0,
                discount_percent: 0,
            }

            const conceptCalculation = []

            // Each invoice
            invoices.forEach((invoice) => {
                // Define client
                if (!bill.client) bill.client = invoice?.client?._EntityId
                if (!bill.client_address) bill.client_address = invoice.client_address
                if (!bill.client_cif) bill.client_cif = invoice?.client?.cif
                if (!bill.client_country) bill.client_country = invoice.client_country
                if (!bill.client_location) bill.client_location = invoice.client_location
                if (!bill.client_name) bill.client_name = invoice.client_name
                if (!bill.client_legal_name) bill.client_legal_name = invoice.client_legal_name
                if (!bill.client_cp) bill.client_cp = invoice.client_cp
                if (!bill.client_state) bill.client_state = invoice.client_state

                // Each invoice concept
                invoice.concepts.forEach((concept) => {
                    const billConcept = {
                        article: concept.article,
                        expiration_date: concept.expiration_date,
                        lot: concept.lot,
                        text: concept.name,
                        price: concept.price,
                        quantity: concept.quantity,
                        invoice_concept: invoice._EntityId,

                        // Calculations
                        discount: concept.discount,
                        discount_value: concept.discount_value,
                        iva: concept.iva,
                        iva_value: concept.iva_value,
                        surcharge: concept.surcharge,
                        surcharge_value: concept.surcharge_value,
                    }

                    bill.concepts.push(billConcept)

                    conceptCalculation.push(
                        calculation.concept({
                            price: concept.price,
                            quantity: concept.quantity,
                            discount: concept.discount,
                            iva: concept.iva,
                            surcharge: concept.surcharge,
                        })
                    )
                })
            })

            const totalCalculation = calculation.totals(conceptCalculation)

            // Calculations
            bill.subtotal = totalCalculation.subtotal
            bill.total = totalCalculation.total
            bill.iva = totalCalculation.iva.value
            bill.iva_percent = totalCalculation.iva.percent
            bill.discount = totalCalculation.discount.value
            bill.discount_percent = totalCalculation.discount.percent
            bill.surcharge = totalCalculation.surcharge.value
            bill.surcharge_percent = totalCalculation.surcharge.percent

            // Concepts
            bill.concepts = JSON.stringify(bill.concepts)

            // Obtenemos el ultimo numero de serie
            const serie = await series.getSerialNumber('FACTURAS')

            if (serie) {
                bill.serie = serie.value
                bill.serie_r = serie.data._EntityId

                const res = await this.$gestios.items('bills').add({
                    params: bill,
                    view: 'billsForm',
                    silent: true,
                })

                if (res.ok) {
                    await series.editSerialValue(bill.serie_r)

                    // Assign the bill to the invoices
                    for (let i = 0; i < invoices.length; i++) {
                        const invoice = invoices[i]

                        await this.$gestios.items('invoices').edit({
                            id: invoice._EntityId,
                            params: {
                                invoice: res.data._EntityId,
                            },
                            view: 'invoiceList',
                            silent: true,
                        })
                    }

                    this.$gestios.$message.success('Proceso de conversión terminado 😄')
                } else {
                    this.$gestios.$message.error(`Ocurrio un error agrupando los albaranes`)
                }

                this.$refs.invoicesTable.checkAll(false)
                this.converting = false
                this.combineForm.visible = false
            }
        },
        async transformInvoicesToBills(invoices) {
            if (!invoices.length) return

            this.converting = true

            for (let i = 0; i < invoices.length; i++) {
                const invoice = invoices[i]
                const haveInvoice = invoice.invoice && invoice.invoice._EntityId ? true : false

                const bill = {
                    // Sync
                    _internal_invoice_id: invoice._EntityId,

                    // Client
                    client: invoice?.client?._EntityId,
                    client_address: invoice.client_address,
                    client_cif: invoice?.client?.cif,
                    client_country: invoice.client_country,
                    client_location: invoice.client_location,
                    client_name: invoice.client_name,
                    client_legal_name: invoice.client_legal_name,
                    client_cp: invoice.client_cp,
                    client_state: invoice.client_state,

                    // Datos generales
                    _EntityId: null,
                    date: invoice.date,
                    status: 0, // por defecto el estado de "Pendiente"
                    observations: invoice.observations,

                    // Calculations
                    total: invoice.total,
                    subtotal: invoice.subtotal,
                    surcharge: invoice.surcharge,
                    surcharge_percent: invoice.surcharge_percent,
                    iva: invoice.iva,
                    iva_percent: invoice.iva_percent,
                    discount: invoice.discount,
                    discount_percent: invoice.discount_percent,
                }

                // Transformamos los conceptos y calculamos el iva
                const concepts = invoice.concepts.map((concept) => {
                    const billConcept = {
                        article: concept.article,
                        expiration_date: concept.expiration_date,
                        lot: concept.lot,
                        text: concept.name,
                        price: concept.price,
                        quantity: concept.quantity,
                        discount: concept.discount,
                        discount_value: concept.discount_value,
                        iva: concept.iva,
                        iva_value: concept.iva_value,
                        surcharge: concept.surcharge,
                        surcharge_value: concept.surcharge_value,
                    }

                    // Retornamos
                    return billConcept
                })

                // Concepts
                bill.concepts = JSON.stringify(concepts)

                let completed = true

                // Si es una factura existente
                if (haveInvoice) {
                    bill._EntityId = invoice.invoice._EntityId

                    const res = await this.$gestios.items('bills').edit({
                        id: bill._EntityId,
                        params: bill,
                        view: 'billList',
                        silent: true,
                    })

                    completed = res.ok
                } else {
                    // Get new serial number
                    const serie = await series.getSerialNumber('FACTURAS')

                    if (serie) {
                        bill.serie = serie.value
                        bill.serie_r = serie.data._EntityId

                        const res = await this.$gestios.items('bills').add({
                            params: bill,
                            view: 'billList',
                            silent: true,
                        })

                        completed = res.ok

                        if (res.ok) {
                            //Increase serial number
                            await series.editSerialValue(serie.data._EntityId)

                            // Si es el ok añadimos el id de la factura al albaran
                            const updateInvoice = await this.$gestios.items('invoices').edit({
                                id: invoice._EntityId,
                                params: {
                                    invoice: res.data._EntityId,
                                },
                                view: 'invoiceList',
                                silent: true,
                            })

                            completed = updateInvoice.ok
                        }
                    } else {
                        this.$gestios.$message.error(
                            `No se pudo obtener el siguiente numero de serie para la factura con albaran `
                        )
                    }
                }

                if (completed) {
                    this.$gestios.$message.success(
                        `Proceso de conversión terminado para el albarán ${invoice._EntityId} [${i + 1}/${
                            invoices.length
                        }] 😄`
                    )
                } else {
                    this.$gestios.$message.error(`Ocurrio un error procesando el albarán: ${invoice._EntityId}}`)
                }
            }

            this.$gestios.$message.success('Se procedera a generar los PDF de las facturas nuevas')

            this.converting = false
        },
    },
}
